import { useEffect, useSyncExternalStore } from 'react'
import { parseTrail, walkTrail, type TrailStep } from './staff-nav'

/* ERP shell · the trail of the session (sessionStorage, with try/catch: without storage it lives in this page only).
   AppShell records every Staff screen; menu, tabs and the frente switch call markFreshNav() first so the trail restarts. */

const KEY = 'cf-erp-trail'
let trail: TrailStep[] = (() => {
    try {
        return parseTrail(window.sessionStorage.getItem(KEY))
    } catch {
        return []
    }
})()
let fresh = false
const listeners = new Set<() => void>()

function set(next: TrailStep[]) {
    trail = next
    try {
        window.sessionStorage.setItem(KEY, JSON.stringify(next))
    } catch {
        // sem armazenamento: vale só nesta página
    }
    for (const l of listeners) l()
}

/** The next screen starts a new trail (menu item, area tab, frente switch). */
export function markFreshNav() {
    fresh = true
}

function record(path: string) {
    const next = walkTrail(trail, path, fresh)
    fresh = false
    if (next.length === trail.length && next.every((s, i) => s.path === trail[i]?.path)) return
    set(next)
}

const subscribe = (l: () => void) => {
    listeners.add(l)
    return () => listeners.delete(l)
}

export function useTrail(): TrailStep[] {
    return useSyncExternalStore(subscribe, () => trail, () => trail)
}

/** Records the current Staff screen (call once, in AppShell). */
export function useRecordTrail(pathname: string, enabled: boolean) {
    useEffect(() => {
        if (enabled) record(pathname)
    }, [pathname, enabled])
}
